module.exports = __webpack_public_path__ + "img/procedure_register.60c4ab94.png";